const NAME = 'LOTAME';
const CNameMapping = {
  [NAME]: NAME,
  Lotame: NAME,
  lotame: NAME,
};

export { NAME, CNameMapping };
